module.exports = __webpack_public_path__ + "static/media/logo.5ae4813d.png";